import React, { memo } from 'react';

import styles from './FormIcon.module.css';

const FormIcon = () => (
  <div className={styles.wrapper}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 94 94">
      <defs>
        <filter
          id="Ellipse_24"
          x="0"
          y="0"
          width="94"
          height="94"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="5" dy="5" />
          <feGaussianBlur stdDeviation="4" result="blur" />
          <feFlood floodOpacity=".161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g transform="translate(-1558 -289)">
        <g transform="translate(1558 289)" filter="url(#Ellipse_24)">
          <circle
            cx="35"
            cy="35"
            r="35"
            transform="translate(7 7)"
            fill="#fff"
          />
        </g>
        <g>
          <circle
            fill="none"
            stroke="#00b2a2"
            strokeWidth="2px"
            strokeMiterlimit="10"
            cx="25"
            cy="25"
            r="25"
            transform="translate(1575 306)"
          />
          <g transform="translate(1587.034 312.945)">
            <path
              d="M6.33 6.411a9.148 9.148 0 0 1 12.821 0 8.873 8.873 0 0 1 0 12.66 9.148 9.148 0 0 1-12.821 0 8.873 8.873 0 0 1 0-12.66z"
              fill="none"
              stroke="#00b2a2"
              strokeWidth="2"
            />
            <path
              fill="none"
              stroke="#00b2a2"
              strokeWidth="2px"
              strokeMiterlimit="10"
              d="M33.415 44.743v-9.512a10.058 10.058 0 0 0-20.115 0v9.512"
              transform="translate(-10.472 -3.507)"
            />
          </g>
        </g>
      </g>
    </svg>
  </div>
);

export default memo(FormIcon);
